(function () {
  angular.module('MktzapApp.Factories')
    .factory('WhiteListService', WhiteListService);

  WhiteListService.$inject = ['$resource'];

  function WhiteListService ($resource) {
    return $resource(apiUrl + '/channels-plugin/white-list/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      deleteContact: { url: apiUrl + '/channels-plugin/white-list/delete-contact', method: 'POST', isArray: false },
      loadChannels: { url: apiUrl + '/channels-plugin/white-list/load-channels', method: 'POST', isArray: true },
      getByChannelId: { url: apiUrl + '/channels-plugin/white-list/get-by-channel-id', method: 'POST', isArray: true }
    });
  }
})();
